var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { URLs } from "../url";
import { fetchRequestResponse } from "../fetchRequest";
import { getHeader, getHeaderLogin } from "../headers";
var getHost = function () {
    var origin = window.location.origin;
    return origin;
};
var handleMicrosoftLogin = function (data) {
    var params = new URLSearchParams({
        client_id: process.env.REACT_APP_MICROSOFT_CLIENT_ID || "",
        response_type: "token",
        redirect_uri: getHost() || "http://localhost:3000",
        scope: "openid email profile offline_access User.Read",
    });
    var authUrl = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?".concat(params.toString());
    window.location.href = authUrl;
};
var postSSOValidation = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var response, data, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch(process.env.REACT_APP_HOST_API + URLs.msLogin, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            data: {
                                token: token,
                            },
                        }),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("HTTP error! status: ".concat(response.status));
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                console.log("SSO Validation Response:", data);
                return [2 /*return*/, data];
            case 3:
                error_1 = _a.sent();
                console.error("Error during SSO validation:", error_1);
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
var postLoginAPI = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API + URLs.login;
                requestOptions = {
                    method: "POST",
                    body: JSON.stringify({ userName: body.userName, password: body.password }),
                    headers: getHeaderLogin(),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchRequestResponse(newURL, requestOptions)];
            case 2: return [2 /*return*/, (_a.sent())];
            case 3:
                err_1 = _a.sent();
                throw err_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
var byPassLogin = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API + URLs.byPassLogin;
                requestOptions = {
                    method: "POST",
                    body: [],
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json, text/plain, */*",
                        Authorization: "Bearer " + token,
                    },
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchRequestResponse(newURL, requestOptions)];
            case 2: return [2 /*return*/, (_a.sent())];
            case 3:
                err_2 = _a.sent();
                throw err_2;
            case 4: return [2 /*return*/];
        }
    });
}); };
var UserGet = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var usersUrl, orderBy, orderDir, enabled, deleted, hasRole, page, limit, roles, branch, query, newURL, requestOptions, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                usersUrl = (body === null || body === void 0 ? void 0 : body.users) ? "&users=".concat(body.users) : "";
                orderBy = (body === null || body === void 0 ? void 0 : body.orderBy) ? "&orderBy=".concat(body.orderBy) : "";
                orderDir = (body === null || body === void 0 ? void 0 : body.orderDir) ? "&orderDir=".concat(body.orderDir) : "";
                enabled = (body === null || body === void 0 ? void 0 : body.enabled) !== undefined ? "&enabled=".concat(body.enabled) : "";
                deleted = (body === null || body === void 0 ? void 0 : body.deleted) ? "&deleted=".concat(body.deleted) : "";
                hasRole = (body === null || body === void 0 ? void 0 : body.hasRole) ? "&hasRole=".concat(body.hasRole) : "";
                page = (body === null || body === void 0 ? void 0 : body.page) ? "&page=".concat(body.page) : "";
                limit = (body === null || body === void 0 ? void 0 : body.limit) ? "&limit=".concat(body.limit) : "";
                roles = (body === null || body === void 0 ? void 0 : body.roles) ? "&roles=".concat(body.roles) : "";
                branch = (body === null || body === void 0 ? void 0 : body.branch) ? "&branch=".concat(body.branch) : "";
                query = (body === null || body === void 0 ? void 0 : body.query) ? "&query=".concat(body.query) : "";
                newURL = "".concat(process.env.REACT_APP_HOST_API).concat(URLs.user, "?").concat(usersUrl).concat(orderBy).concat(orderDir).concat(enabled).concat(page).concat(limit).concat(deleted).concat(hasRole).concat(roles).concat(branch).concat(query);
                requestOptions = {
                    method: "GET",
                    headers: getHeader(),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchRequestResponse(newURL, requestOptions)];
            case 2: return [2 /*return*/, (_a.sent())];
            case 3:
                error_2 = _a.sent();
                throw error_2;
            case 4: return [2 /*return*/];
        }
    });
}); };
var userCreateUser = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API + URLs.user;
                requestOptions = {
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: getHeader(),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchRequestResponse(newURL, requestOptions)];
            case 2: return [2 /*return*/, (_a.sent())];
            case 3:
                error_3 = _a.sent();
                throw error_3;
            case 4: return [2 /*return*/];
        }
    });
}); };
var userInitPasswordReset = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API + URLs.user + "/InitPasswordReset";
                requestOptions = {
                    method: "POST",
                    body: JSON.stringify({ userName: email }),
                    headers: getHeader(),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchRequestResponse(newURL, requestOptions)];
            case 2: return [2 /*return*/, (_a.sent())];
            case 3:
                error_4 = _a.sent();
                throw error_4;
            case 4: return [2 /*return*/];
        }
    });
}); };
var userConfirmPasswordReset = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API + URLs.user + "/ConfirmPasswordReset";
                requestOptions = {
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: getHeader(),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchRequestResponse(newURL, requestOptions)];
            case 2: return [2 /*return*/, (_a.sent())];
            case 3:
                error_5 = _a.sent();
                throw error_5;
            case 4: return [2 /*return*/];
        }
    });
}); };
var userConfirmEmail = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API + URLs.user + "/ConfirmEmail";
                requestOptions = {
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: getHeader(),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchRequestResponse(newURL, requestOptions)];
            case 2: return [2 /*return*/, (_a.sent())];
            case 3:
                err_3 = _a.sent();
                throw err_3;
            case 4: return [2 /*return*/];
        }
    });
}); };
var getUserById = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API +
                    URLs.user +
                    "?users=".concat(id, "&enabled=true&page=1&limit=10");
                requestOptions = {
                    method: "GET",
                    headers: getHeader(),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchRequestResponse(newURL, requestOptions)];
            case 2: return [2 /*return*/, (_a.sent())];
            case 3:
                error_6 = _a.sent();
                throw error_6;
            case 4: return [2 /*return*/];
        }
    });
}); };
var userPatch = function (body, id) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API + URLs.user + "/".concat(id);
                requestOptions = {
                    method: "PATCH",
                    body: JSON.stringify({
                        firstName: body.name,
                        lastName: body.lastName,
                    }),
                    headers: getHeader(),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchRequestResponse(newURL, requestOptions)];
            case 2: return [2 /*return*/, (_a.sent())];
            case 3:
                error_7 = _a.sent();
                throw error_7;
            case 4: return [2 /*return*/];
        }
    });
}); };
var userPutRol = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API + URLs.user + "/Roles";
                requestOptions = {
                    method: "PUT",
                    body: JSON.stringify({
                        id: body.id,
                        roles: body.roles,
                    }),
                    headers: getHeader(),
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchRequestResponse(newURL, requestOptions)];
            case 2: return [2 /*return*/, (_a.sent())];
            case 3:
                error_8 = _a.sent();
                throw error_8;
            case 4: return [2 /*return*/];
        }
    });
}); };
export { postLoginAPI, userCreateUser, userInitPasswordReset, userConfirmPasswordReset, userConfirmEmail, userPatch, UserGet, getUserById, userPutRol, byPassLogin, handleMicrosoftLogin, postSSOValidation, };
